import React from 'react';
import PropTypes from 'prop-types';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import './PurchaseOrderItemStatusBadge.css';

export default function PurchaseOrderItemStatusBadge({item, compact, centered, inline}) {
    if (!item) {
        return null;
    }

    const isCompact = compact ?? GeneralUtils.isMobile();
    const isInline = inline === true;

    let badge = null;

    if (item.status === 'PASSIVE') {
        badge = (
            <span className={`po-item-status po-item-status--ignored${isInline ? ' po-item-status--inline' : ''}`} title="Ignored">
                <span className="po-item-status__text">{isCompact ? 'I' : 'IGNR'}</span>
            </span>
        );
    } else if (item.barcodeIsSearched === false) {
        badge = (
            <span
                className={`po-item-status po-item-status--pending po-item-status--pulse${isInline ? ' po-item-status--inline' : ''}`}
                title="Barcode not searched"
            >
                <i className="pi pi-exclamation-triangle po-item-status__icon" aria-hidden="true"/>
            </span>
        );
    } else if (!item.itemBssId) {
        badge = (
            <span
                className={`po-item-status po-item-status--new po-item-status--pulse${isInline ? ' po-item-status--inline' : ''}`}
                title="New product"
            >
                <span className="po-item-status__text">N</span>
            </span>
        );
    } else {
        badge = (
            <span className={`po-item-status po-item-status--matched${isInline ? ' po-item-status--inline' : ''}`} title="Matched">
                <i className="pi pi-check po-item-status__icon" aria-hidden="true"/>
            </span>
        );
    }

    if (!centered) {
        return badge;
    }

    return <span className="po-item-status-cell">{badge}</span>;
}

PurchaseOrderItemStatusBadge.propTypes = {
    item: PropTypes.object,
    compact: PropTypes.bool,
    centered: PropTypes.bool,
    inline: PropTypes.bool,
};
